import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "WTF is X-Frame-Options?",
  "description": "",
  "published": "2016-10-13T00:00:00.000Z",
  "redirect_from": ["/blog/x-frame-options/swizec/7115"],
  "categories": "coding, QA, Technical, x-frame-options",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here’s a fun way to waste an afternoon:`}</p>
    <ol>
      <li parentName="ol">{`You have a user flow that involves reading user docs: some gDocs, some YouTube videos, and some UI practice links of your own.`}</li>
      <li parentName="ol">{`Opening these in a new tab is annoying, right?`}</li>
      <li parentName="ol">{`So you move them into modals using `}<inlineCode parentName="li">{`iframe`}</inlineCode>{`s`}</li>
      <li parentName="ol">{`Everything works! ??`}</li>
      <li parentName="ol">{`Then, you give it to QA…`}</li>
      <li parentName="ol">{`2 out of 8 links don’t open for them.`}</li>
      <li parentName="ol">{`O.o`}</li>
    </ol>
    <p>{`Every link opens a modal with an iframe. That part works. Two of the links – a YouTube video and a UI practice widget – never load.`}</p>
    <p>{`You think it might be a slowness issue because you wait a few seconds and there’s no loading indicator. So you ask them to wait… doesn’t help. QA waits for many minutes but the two `}<inlineCode parentName="p">{`iframe`}</inlineCode>{`s stay blank.`}</p>
    <p>{`o.O`}</p>
    <p>{`You investigate. It still works for you. But QA is using Windows.`}</p>
    <p>{`You find a Windows machine, do the Windows 10 forced update dance, and download the latest Chrome. It’s not a computer you use very often. The touchpad feels funny.`}</p>
    <p>{`The two `}<inlineCode parentName="p">{`iframe`}</inlineCode>{`s, they don’t load. Wut.`}</p>
    <p>{`The console sheds a clue: Refused to display because it set `}<inlineCode parentName="p">{`X-Frame-Options`}</inlineCode>{` to `}<inlineCode parentName="p">{`SAMEORIGIN`}</inlineCode>{`.`}</p>
    <p>{`What the hell is X-Frame-Options? Why does Google `}<a parentName="p" {...{
        "href": "https://www.google.com/search?q=x-frame-options&oq=x-frame&aqs=chrome.0.0j69i57j69i61j0l3.1573j0j1&sourceid=chrome&ie=UTF-8"
      }}>{`only return results`}</a>{` and StackOverflow questions from 2010, 2012, and 2013. Most of them still in PHP! Why have I not heard of this!?`}</p>
    <hr></hr>
    <p><inlineCode parentName="p">{`X-Frame-Options: SAMEORIGIN`}</inlineCode>{` is an HTTP header that guards websites against clickjacking attacks. It tells browsers, `}<em parentName="p">{`“Yo, don’t open this page in an iframe”`}</em>{`.`}</p>
    <p>{`YouTube sets the header for URLs that aren’t `}<inlineCode parentName="p">{`embed`}</inlineCode>{` links, which explains the single YT link that didn’t work in my case. I was using `}<inlineCode parentName="p">{`embed`}</inlineCode>{` links for all but one of them. ?`}</p>
    <p>{`And our own practice-the-interface link?`}</p>
    <p>{`Rails 4 sets `}<inlineCode parentName="p">{`X-Frame-Options: SAMEORIGIN`}</inlineCode>{` for everything as a default security measure. I just never noticed before.`}</p>
    <p>{`At least it was easy to fix – don’t send the header. :D`}</p>
    <p>{`But why did it work on `}<em parentName="p">{`my`}</em>{` computer?`}</p>
    <p>{`At first, I thought maybe it’s because Chrome Mac and Chrome Windows behave differently. I tried on a coworker’s machine, and it didn’t work. It stopped the `}<inlineCode parentName="p">{`iframe`}</inlineCode>{`s like it’s supposed to.`}</p>
    <p>{`Then I thought, “Maybe it’s because I’m on localhost.” Nope, wasn’t that.`}</p>
    <p>{`Maybe it figures out `}<inlineCode parentName="p">{`swizec.ngrok.io`}</inlineCode>{` points to my local machine? Wait… the YouTube link worked, so it can’t be that.`}</p>
    <p>{`…Why doesn’t my computer protect me from clickjacking? This is not ideal…`}</p>
    <p>{`But hey, at least I know about X-Frame-Options now. That was fun. ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      